import React from 'react';
import { useAuth } from '../context/AuthContext';

// Tela de bloqueio: a API responde 403 EMPRESA_SUSPENSA em todas as rotas do tenant
// (inadimplência > 5 dias ou empresa desativada no master). O interceptor do api.js manda pra cá.
export default function Suspenso() {
  const { logout } = useAuth();
  const sair = () => { logout(); window.location.href = '/login'; };
  const temSessao = !!localStorage.getItem('token');

  return (
    <div style={{ minHeight: '100vh', background: '#F0F3F7', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', fontFamily: "'DM Sans',system-ui,sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: '14px', padding: '40px 32px', maxWidth: '420px', width: '100%', textAlign: 'center', boxShadow: '0 4px 24px rgba(11,22,40,0.08)' }}>
        <div style={{ fontSize: '40px', marginBottom: '12px' }}>🔒</div>
        <div style={{ fontSize: '20px', fontWeight: '800', color: '#0B1628', marginBottom: '10px' }}>Sistema suspenso</div>
        <div style={{ fontSize: '14px', color: '#6B7A8D', marginBottom: '28px' }}>Entre em contato para regularizar.</div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          {temSessao && (
            <button onClick={() => { window.location.href = '/dashboard'; }}
              style={{ padding: '10px 18px', background: '#1A6DFF', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>Já regularizei</button>
          )}
          <button onClick={sair}
            style={{ padding: '10px 18px', background: '#F4F6F9', color: '#0B1628', border: '1px solid #D8DEE6', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}>{temSessao ? 'Sair' : 'Voltar ao login'}</button>
        </div>
      </div>
    </div>
  );
}
